import React from 'react';
import { StethoscopeIcon, GlobeIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { HERO_IMAGE } from '../../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream px-4 pb-14 pt-7 sm:px-6 sm:pt-10" data-id="element-224" data-mp="hvz4dzzy5igi">
      <div className="relative mx-auto max-w-5xl" data-id="element-225" data-mp="mszc0fcg2t9q">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-226" data-mp="ms7ozswwy3v2">
          <Logo data-id="element-227" data-mp="qtj6tc9jpksp" />
          <span className="inline-flex items-center gap-1.5 rounded-full border border-navy/10 bg-white px-3 py-1.5 text-[10.5px] font-extrabold uppercase tracking-[0.1em] text-navy/75 shadow-card sm:text-[11.5px]" data-id="element-228" data-mp="vmcb5z13qr49">
            <StethoscopeIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-229" data-mp="15l1vrzkdupo7" />
            The 5-Min Menopause™ Clinical Method
          </span>
        </div>

        <h1 className="mt-7 text-center font-display text-[32px] font-bold leading-[1.1] tracking-tight text-navy sm:text-5xl lg:text-[58px]" data-id="element-230" data-mp="1ahilgy78dc3e">
          Structure a menopause visit in 5 steps —{' '}
          <em className="not-italic text-rose sm:italic" data-id="element-231" data-mp="4qsqdd3q2yli">in under 5 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15.5px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-232" data-mp="3vx3op1hcll95">
          A practical clinical decision system that turns scattered menopause information into a
          clear, structured workflow for <strong className="font-semibold text-navy" data-id="element-233" data-mp="nepg2pcit87j">assessment,
          risk review, treatment decisions, and follow-up</strong>. Includes{' '}
          <strong className="font-semibold text-navy" data-id="element-234" data-mp="imo7bdek9zm9">6 premium guides</strong>,{' '}
          <strong className="font-semibold text-navy" data-id="element-235" data-mp="em469yqvabuu">30+ clinical tools</strong>, decision
          algorithms, checklists, practical cases, and{' '}
          <strong className="font-semibold text-navy" data-id="element-236" data-mp="16ebq181o64dg">5 exclusive bonuses</strong>.
        </p>

        <figure className="mx-auto mt-8 w-full max-w-3xl" data-id="element-237" data-mp="30lxcu7ra86vn">
          <img src={HERO_IMAGE} alt="The 6 guides and 5 bonuses included in 5-MIN MENOPAUSE™, shown as printed volumes, a tablet, a phone, and printed clinical tools" className="w-full" loading="eager" data-id="element-238" data-mp="30mfgvqk6rpe4" />
          <figcaption className="mt-1 text-center text-[12px] font-semibold uppercase tracking-[0.1em] text-navy/50" data-id="element-239" data-mp="2vufdtp8tkgdb">
            The 6 guides + 5 bonuses inside 5-MIN MENOPAUSE™
          </figcaption>
        </figure>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-240" data-mp="2mvag2l530r27">
          <CtaButton label="Yes, I want 5-MIN MENOPAUSE™" subtext="Instant access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-241" data-mp="27x9og3b8l1dv" />
        </div>
        <div id="hero-cta-anchor" aria-hidden="true" className="h-px w-full" data-id="element-242" data-mp="2cy60x59nlvuw" />

        <div className="mx-auto mt-8 max-w-xl" data-id="element-243" data-mp="66oeqnyyep7k">
          <CountdownTimer data-id="element-244" data-mp="b5hvcp9jewby" />
        </div>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-245" data-mp="b46t4tvqpwmy">
          <ScarcityBar data-id="element-246" data-mp="1vmhbik9evinl" />
          <p className="mt-3 flex items-start justify-center gap-1.5 text-center text-[12.5px] font-medium text-navy/60" data-id="element-247" data-mp="1vo25o8rtczkx">
            <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal" aria-hidden="true" data-id="element-248" data-mp="1qpqwm09cet3r" />
            Your currency is converted automatically at checkout where supported.
          </p>
        </div>
      </div>
    </header>;
}